// extracted by mini-css-extract-plugin
export default {"empty_state_document":"AwardApproval_empty_state_document__tryqc","empty_state_msg":"AwardApproval_empty_state_msg__fLIDM"};